import { render, staticRenderFns } from "./flat.vue?vue&type=template&id=5fb40894&scoped=true"
import script from "./flat.vue?vue&type=script&lang=js"
export * from "./flat.vue?vue&type=script&lang=js"
import style0 from "./flat.vue?vue&type=style&index=0&id=5fb40894&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb40894",
  null
  
)

export default component.exports